module.exports = __webpack_public_path__ + "static/img/team-pic6.7a43af93.png";